import { AddText } from '@/pages/AdvancedEditor/components/panels/text/AddText';
import { ModifyText } from '@/pages/AdvancedEditor/components/panels/text/ModifyText';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';

const TextPanelContainer = styled.div`
    padding: 0 20px !important;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const TextPanel = observer(() => {
    const { store } = useAdvancedEditorContext();
    const element = store.selectedElements[0];

    return (
        <TextPanelContainer data-testid="text-panel">
            {!element && <AddText />}
            {!!element && <ModifyText />}
        </TextPanelContainer>
    );
});
